// NOTICE: SvelteComponent is Svelte 4 and Component is Svelte 5, however storyblok is still using Svelte 4 typings
import { PUBLIC_STORYBLOK_TOKEN } from "$env/static/public";
import type { SvelteComponent } from "svelte";

import {
  Section,
  Page,
  CollectionCardGrid,
  ProductFeed,
  RichText,
  CampaignCard,
  StoryRow,
  FooterRow,
  FooterLinkColumn,
  FooterLink,
  FooterCollectionLink,
  FooterGroup,
  Divider,
  BlogFrontPage,
  BlogCategory,
  BlogPost,
  BlogCard,
  ImageContent,
  Heading,
  Button,
  TextSection,
  CardColumns,
  IconCard,
  TextCard,
  ImageCard,
  StatCard,
  TypeFormEmbed,
} from "./components";

import AccordionSection from './components/accordion-section/accordion-section.svelte';
import AccordionItem from './components/accordion-item/accordion-item.svelte';
import Blacklist from './components/blacklist/blacklist.svelte';

export const initStoryblok = async () => {
  const { storyblokInit, apiPlugin } = await import('@storyblok/svelte');

  return storyblokInit({
    accessToken: PUBLIC_STORYBLOK_TOKEN,
    use: [apiPlugin],
    apiOptions: {},
    components: {
      'page': Page,
      'section': Section,
      'collectionCardGrid': CollectionCardGrid,
      'productFeed': ProductFeed,
      'richText': RichText,
      'campaignCard': CampaignCard,
      'storyRow': StoryRow,
      'footerRow': FooterRow,
      'footerLinkColumn': FooterLinkColumn,
      'link': FooterLink,
      'collectionLink': FooterCollectionLink,
      'footerGroup': FooterGroup,
      'divider': Divider,
      'blogFrontPage': BlogFrontPage,
      'blogCategory': BlogCategory,
      'blogPost': BlogPost,
      'blogCard': BlogCard,
      'imageContent': ImageContent,
      'heading': Heading,
      'button': Button,
      'textSection': TextSection,
      'cardColumns': CardColumns,
      'iconCard': IconCard,
      'statCard': StatCard,
      'textCard': TextCard,
      'imageCard': ImageCard,
      'typeFormEmbed': TypeFormEmbed,
      'accordionSection': AccordionSection,
      'accordionItem': AccordionItem,
      'blacklist': Blacklist,
    } as unknown as Record<string, typeof SvelteComponent<any>> // Fixes issues with Svelte 5 typings
  });
};